export localStorage from 'effects/localStorage'
export log from 'effects/log'
export seed from 'effects/seed'
export resize from 'effects/resize'
export setup from 'effects/setup'
export view from 'effects/view'



/** WEBPACK FOOTER **
 ** ./effects/index.js
 **/